<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>每日奖励配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:dailyReward:add']" size="mini" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <clear-cache-apply />
          </div>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="500px;">
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>
          <el-dialog title="提示" :visible.sync="dialogVisibleScoreEvent" width="500px">
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option v-for="item in groups" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>
        </div>
        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option v-for="item in groups" :key="item.value" :label="item.label" :value="item.value" />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form>
                        <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                          <el-form-item label="每日进度配置">
                            <el-card class="box-card">
                              <el-form :inline="true" style="margin-top: 10px;">
                                <el-form-item label="重置时间(小时)">
                                  <el-input v-model.number="item.days.resetTime" style="width: 100px;" placeholder="重置时间(小时)" />
                                </el-form-item>
                                <el-table :data="item.days.config" border stripe style="margin-top: 10px">
                                  <el-table-column prop="count" label="权重" width="100">
                                    <template slot-scope="scope">
                                      <el-input-number v-model.number="scope.row.v" :controls="false" style="width: 80%;" />
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="progress" label="进度" width="100px">
                                    <template slot-scope="scope">
                                      <el-input v-model.number="scope.row.progress" />
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="type" label="任务">
                                    <template slot-scope="scope">
                                      <el-select v-model="scope.row.type" placeholder="请选择" @change="(v)=>{return tasktypeChange(v, tabItem.label, scoreItem.group_name, true)}">
                                        <el-option v-for="item in disableType[tabItem.label][scoreItem.group_name]" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled" />
                                      </el-select>
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="count" label="次数">
                                    <template slot-scope="scope">
                                      <el-input v-model.number="scope.row.count" />
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="count" label="积分">
                                    <template slot-scope="scope">
                                      <el-input-number v-model.number="scope.row.point" :controls="false" :min="1" />
                                    </template>
                                  </el-table-column>
                                  <el-table-column label="奖励">
                                    <template slot-scope="scope">
                                      <commonReward v-model="scope.row.prize" />
                                    </template>
                                  </el-table-column>
                                  <el-table-column label="操作">
                                    <template slot-scope="scope">
                                      <el-button type="danger" @click="delDay(tabItem.label,scoreItem.group_name, score_index, scope.$index)">删除</el-button>
                                    </template>
                                  </el-table-column>
                                </el-table>
                              </el-form>
                              <el-form-item style="margin-top: 10px;">
                                <el-button type="primary" @click="addDay(tabItem.label,scoreItem.group_name, score_index)">+</el-button>
                              </el-form-item>
                            </el-card>
                          </el-form-item>
                          <el-form-item label="每周进度配置">
                            <el-card class="box-card">
                              <el-table :data="item.week" border stripe>
                                <el-table-column prop="progress" label="进度" width="120px">
                                  <template slot-scope="scope">
                                    <el-input v-model.number="scope.row.progress" />
                                  </template>
                                </el-table-column>
                                <el-table-column label="奖励">
                                  <template slot-scope="scope">
                                    <commonReward v-model="scope.row.prize" />
                                  </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                  <template slot-scope="scope">
                                    <el-button type="danger" @click="delWeekStage(tabItem.label,scoreItem.group_name, score_index, scope.$index)">删除</el-button>
                                  </template>
                                </el-table-column>
                              </el-table>
                              <el-button type="primary" @click="addWeekStage(tabItem.label,scoreItem.group_name, score_index)">+</el-button>
                            </el-card>
                          </el-form-item>
                          <el-button v-permisaction="['config:dailyReward:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name ,item.id)">删除</el-button>
                          <el-button v-permisaction="['config:dailyReward:add']" type="primary" @click="onSubmit()">保存</el-button>
                        </el-row>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import { getDailyRewardCfgList, updateDailyRewardCfg, delFirstCfg } from '@/api/config/daily-reward-cfg'
import { getRewardListForPropsId } from '@/utils'
import commonReward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'PopUp',
  components: {
    SyncData,
    ClearCacheApply,
    commonReward
  },
  data() {
    return {
      skinId: [62, 19, 67, 68],
      shield: [],
      sieve: [],
      chessId: [],
      areaId: [],
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      taskType: [{
        label: '每日签到',
        value: 1
      }],
      disableType: [],
      types: [
        { label: '建造', value: 1, disabled: false },
        { label: '攻击', value: 2, disabled: false },
        { label: '偷袭', value: 3, disabled: false },
        { label: '投掷', value: 4, disabled: false },
        { label: '消耗体力', value: 5, disabled: false },
        { label: '打开宝箱', value: 6, disabled: false },
        { label: '收租金', value: 7, disabled: false },
        { label: '获取体力事件', value: 8, disabled: false },
        { label: '转到三角事件', value: 9, disabled: false }
        // { label: '每经过?次起点', value: 10, disabled: false },
        // { label: '每落点?次冰镐格子', value: 11, disabled: false },
        // { label: '每落点?次钻石支票格子', value: 12, disabled: false },
        // { label: '每落点?次随机卡格子', value: 9, disabled: false },
        // { label: '每落点?次好友基金格子', value: 9, disabled: false }
      ],
      visibleArr: {},
      weekVisibleArr: {},
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      taskRewardType: [{
        label: '固定奖励',
        value: 1
      }, {
        label: '随机奖励',
        value: 2
      }, {
        label: '自选奖励',
        value: 3
      }],
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 }
        // { label: '付费玩家', value: 2 }
      ],
      popType: [
        { 'label': '推送更新', value: 1 },
        { 'label': '签到', value: 2 }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getGroup()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    onSubmit(noTips = false) {
      // const data = JSON.stringify(this.formData)
      // console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          if (scoreItem.data[0].length < 1) {
            continue
          }

          postFormDataCondition[key] = condition

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          const dayLen = _data.days.config.length - 1
          for (const k in _data.days.config) {
            const nextKey = parseInt(k) + 1
            if (nextKey > dayLen) {
              break
            }
            // if (_data.days.config[k].progress > _data.days.config[nextKey].progress) {
            //   this.msgError('每日奖励配置-前一个进度不能大于后面的进度')
            //   return
            // }

            const config = _data.days.config[k]
            for (const rk in config.prize) {
              const p = config.prize[rk]
              if (p.propsId === 65) {
                _data.days.config[k].prize[rk].num *= 10000
              }
            }
          }

          const wdayLen = _data.week.length - 1
          for (const k in _data.week) {
            const nextKey = parseInt(k) + 1
            // console.log('k', k, 'nextKey', nextKey)
            if (nextKey > wdayLen) {
              break
            }
            if (_data.week[k].progress > _data.week[nextKey].progress) {
              this.msgError('每周奖励配置-前一个进度不能大于后面的进度')
              return
            }

            const week = _data.week[k]
            for (const rk in week.prize) {
              const p = week.prize[rk]
              if (p.propsId === 65) {
                _data.week[k].prize[rk].num *= 10000
              }
            }
          }

          // console.log('days', _data.days)
          _data.condition = key
          _postData.push(_data)
        }
      }

      // console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log('_postData', _postData)
      updateDailyRewardCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    handleClose1(d, levelName, scoreName, index) {
      this.weekVisibleArr[levelName][scoreName][index].visible = false
    },
    getTables(actName) {
      this.tabPane = []
      this.formData = []
      getDailyRewardCfgList().then(res => {
        const data = res.data.data
        // console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.visibleArr, levelName, {})
            this.$set(this.weekVisibleArr, levelName, {})
            this.$set(this.disableType, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
            this.$set(this.visibleArr[levelName], scoreName, [])
            this.$set(this.weekVisibleArr[levelName], scoreName, [])
            this.$set(this.disableType[levelName], scoreName, [])
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })
          this.disableType[levelName][scoreName] = this.types
          for (const ii in data) {
            const _event = data[ii]
            console.log('event', _event)
            // console.log('ii', _event.condition + ' -- ' + i)
            if (_event.condition === i) {
              // this.visibleArr[levelName][scoreName].push({ visible: false })
              _event.week.forEach((res, index) => {
                for (const rk in res.prize) {
                  const p = res.prize[rk]
                  if (p.propsId === 65) {
                    _event.week[index].prize[rk].num /= 10000
                  }
                }
                this.weekVisibleArr[levelName][scoreName].push({ visible: false })
              })
              this.$set(this.formData[levelName][scoreName], 'data', [{
                id: _event.id,
                days: _event.days,
                week: _event.week
              }])
              _event.days.config.forEach((item, index) => {
                for (const rk in item.prize) {
                  const p = item.prize[rk]
                  if (p.propsId === 65) {
                    _event.days.config[index].prize[rk].num /= 10000
                  }
                }
                this.visibleArr[levelName][scoreName].push({ visible: false })
                this.tasktypeChange(item.type, levelName, scoreName, true)
              })
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }

          this.levelActiveName = levelName
        }
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groups.push({ label: res.name, value: res.groupId })
        })
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      // console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)

      // 修改弹窗
      const oldWeekVisle = this.weekVisibleArr[oldLevelName]
      Vue.delete(this.weekVisibleArr, oldLevelName)
      this.$set(this.weekVisibleArr, newLevelName, oldWeekVisle)

      // 修改弹窗
      const oldDisabled = this.disableType[oldLevelName]
      Vue.delete(this.disableType, oldLevelName)
      this.$set(this.disableType, newLevelName, oldDisabled)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'task': [
          { taskId: 1, process: 10, reward: [] }
        ],
        'reward': []
      })
      this.visibleArr[levelName][scoreName].push({ visible: false })
      this.weekVisibleArr[levelName][scoreName].push({ visible: false })
      // console.log(this.visibleArr[levelName][scoreName])
    },
    delEvent(levelName, scoreName, id) {
      // console.log(id)
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delFirstCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.$delete(this.formData[levelName], scoreName)
              this.onSubmit(true)
              this.getTables('')
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      // console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
        this.$set(this.weekVisibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      this.weekVisibleArr[score.level_name][scoreTag].push({ visible: false })
      this.$set(this.disableType[score.level_name], scoreTag, this.types)
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        id: 0,
        days: {
          resetTime: 1,
          config: [
            {
              v: 0,
              point: 0,
              progress: 0,
              type: 1,
              count: 1,
              prize: []
            }
          ]
        },
        week: [{
          progress: 1,
          prize: []
        }]
      })

      this.tasktypeChange(1, score.level_name, scoreTag)
      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      this.$set(this.weekVisibleArr, levelName, {})
      this.$set(this.disableType, levelName, {})
    },
    handleClick(tab, event) {
      // console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      // console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName, index, i) {
      // console.log(this.formData[levelName][groupName].data[index].days.config[i])
      this.formData[levelName][groupName].data[index].days.config[i].prize.push(
        {
          propsId: 1, num: 1, rtype: 1
        }
      )
    }, delReward(levelName, groupName, index, i, ri) {
      this.formData[levelName][groupName].data[index].days.config[i].prize = this.formData[levelName][groupName].data[index].days.config[i].prize.filter((item, key) => {
        return key !== ri
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.levelActiveName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)

      // 修改弹窗元素
      const oldWeekVisible = this.weekVisibleArr[levelName][oldGroupName]
      this.$delete(this.weekVisibleArr[levelName], oldGroupName)
      this.$set(this.weekVisibleArr[levelName], newGroupName, oldWeekVisible)

      const oldDisabled = this.disableType[levelName][oldGroupName]
      this.$delete(this.disableType[levelName], oldGroupName)
      this.$set(this.disableType[levelName], newGroupName, oldDisabled)
    },
    addTask(levelName, groupName, index, i) {
      // console.log(this.formData[levelName][groupName].data[index].days[i])
      const d = this.formData[levelName][groupName].data[index].days[i].task.length
      if (d > 2) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][groupName].data[index].days[i].task.push({
        day: d + 1,
        taskId: 1,
        taskRewardType: 1,
        rewardProcess: 0,
        expireTime: 0,
        reward: []
      })
      this.visibleArr[levelName][groupName][index].push({ visible: false })
    },
    delTask(levelName, groupName, index, i, ti) {
      this.formData[levelName][groupName].data[index].days[i].task = this.formData[levelName][groupName].data[index].days[i].task.filter((item, key) => {
        return key !== ti
      })
    },
    addDay(levelName, groupName, index) {
      // console.log(this.disableType[levelName][groupName])
      let _selectType = 0
      for (const i in this.disableType[levelName][groupName]) {
        // console.log(this.disableType[levelName][groupName][i].value, this.disableType[levelName][groupName][i].disabled)
        if (!this.disableType[levelName][groupName][i].disabled) {
          _selectType = this.disableType[levelName][groupName][i].value
          break
        }
      }

      if (_selectType <= 1) {
        this.msgError('可选类型已达上限')
        return
      }
      this.formData[levelName][groupName].data[index].days.config.push(
        {
          progress: 0,
          type: _selectType,
          count: 1,
          point: 1,
          prize: []
        }
      )

      this.visibleArr[levelName][groupName].push({ visible: false })
      this.tasktypeChange(_selectType, levelName, groupName, true)
    },
    delDay(levelName, groupName, index, i) {
      // console.log(this.formData[levelName][groupName].data[index].days.config[i].type)
      const selectType = this.formData[levelName][groupName].data[index].days.config[i].type
      this.disableType[levelName][groupName].forEach((res, index) => {
        if (res.value === selectType) {
          this.disableType[levelName][groupName][index].disabled = false
        }
      })
      this.formData[levelName][groupName].data[index].days.config = this.formData[levelName][groupName].data[index].days.config.filter((item, key) => {
        return key !== i
      })
    }, addWeekStage(levelName, groupName, index) {
      this.formData[levelName][groupName].data[index].week.push({
        progress: 0,
        prize: []
      })
      this.weekVisibleArr[levelName][groupName].push({ visible: false })
    }, delWeekStage(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].week = this.formData[levelName][groupName].data[index].week.filter((res, key) => {
        return i !== key
      })
    }, addWeekReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].week[i].prize.push({ propsId: 1, num: 1, rtype: 1 })
    }, delWeekReward(levelName, groupName, index, i, pi) {
      this.formData[levelName][groupName].data[index].week[i].prize = this.formData[levelName][groupName].data[index].week[i].prize.filter((item, key) => {
        return pi !== key
      })
    }, tasktypeChange(v, levelName, groupName, reset = false) {
      this.disableType[levelName][groupName].forEach((item, index) => {
        this.disableType[levelName][groupName][index].disabled = false
      })

      this.disableType[levelName][groupName].forEach((item, index) => {
        if (v === item.value) {
          this.disableType[levelName][groupName][index].disabled = true
        }
      })

      if (reset) {
        this.formData[levelName][groupName].data[0].days.config.forEach((item) => {
          for (const i in this.disableType[levelName][groupName]) {
            // console.log(this.disableType[levelName][groupName][i].value)
            if (this.disableType[levelName][groupName][i].value === item.type) {
              this.disableType[levelName][groupName][i].disabled = true
              break
            }
          }
        })
      }
    }, getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
